/* KISMET v3.8 — barra "Arma tu 3X1" en colecciones */
(function () {
  var bar = document.querySelector('[data-kb3]');
  if (!bar) return;
  document.body.classList.add('has-kb3');

  var need = parseInt(bar.dataset.qty, 10) || 3;
  var slots = bar.querySelectorAll('.kb3__slot');
  var countEl = bar.querySelector('[data-kb3-count]');
  var titleEl = bar.querySelector('[data-kb3-title]');
  var nEl = bar.querySelector('[data-kb3-n]');
  var baseTitle = bar.dataset.title || (titleEl && titleEl.textContent) || '';
  var protId = (window.KISMET && window.KISMET.protection && window.KISMET.protection.variantId) || null;
  var lastN = -1;

  /* En la colección, el "+" agrega sin abrir el carrito: la barra se llena */
  var C = window.KISMET && window.KISMET.cart;
  if (C && C.add && !C.__kb3) {
    var origAdd = C.add;
    C.add = function (items, opts) {
      opts = opts || {};
      if (opts.open === undefined) opts.open = false;
      return origAdd.call(C, items, opts);
    };
    C.__kb3 = true;
  }

  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function paint(items) {
    var pics = [];
    items.forEach(function (it) {
      if (protId && it.variant_id === protId) return;
      for (var q = 0; q < it.quantity; q++) pics.push({ img: it.image, title: it.product_title });
    });
    var n = pics.length;
    var rem = n % need;
    var done = n > 0 && rem === 0;
    var shown = done ? need : rem;
    var start = n - shown; /* las últimas piezas agregadas llenan el paquete actual */

    slots.forEach(function (slot, i) {
      var p = i < shown ? pics[start + i] : null;
      var had = slot.classList.contains('is-on');
      var img = slot.querySelector('img');
      if (p) {
        if (!img) { img = document.createElement('img'); img.alt = ''; img.loading = 'lazy'; slot.appendChild(img); }
        var src = thumb(p.img);
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
        img.alt = p.title || '';
        slot.classList.add('is-on');
        if (!had && lastN !== -1) { slot.classList.remove('is-pop'); void slot.offsetWidth; slot.classList.add('is-pop'); }
      } else {
        if (img) img.remove();
        slot.classList.remove('is-on', 'is-pop');
      }
    });

    var packs = Math.floor(n / need);
    var left = need - shown;
    var title = baseTitle, txt;
    if (n === 0) txt = 'Elige ' + need + ' y paga solo 1';
    else if (done) { title = packs > 1 ? '¡' + packs + ' paquetes listos!' : '¡Tu ' + need + 'X1 está listo!'; txt = 'Llévate ' + need + ', paga solo 1'; }
    else { txt = 'Te falta' + (left > 1 ? 'n ' : ' ') + left + ' para tu ' + need + 'X1'; if (packs > 0) txt = packs + ' listo' + (packs > 1 ? 's' : '') + ' · ' + txt; }
    if (titleEl) titleEl.textContent = title;
    countEl.textContent = txt;
    if (nEl) nEl.textContent = n;
    if (done && lastN !== -1 && lastN !== n) { bar.classList.remove('is-cheer'); void bar.offsetWidth; bar.classList.add('is-cheer'); }
    bar.classList.toggle('is-done', done);
    bar.classList.toggle('is-empty', n === 0);
    lastN = n;
  }

  var t = null;
  function refresh() {
    clearTimeout(t);
    t = setTimeout(function () {
      fetch((window.KISMET && window.KISMET.routes && window.KISMET.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { paint(c.items || []); })
        .catch(function () {});
    }, 120);
  }

  refresh();
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  var drawer = document.getElementById('CartDrawer');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].type === 'attributes' && list[i].attributeName === 'data-real-count') { refresh(); return; }
        if (list[i].type === 'childList' && list[i].target === drawer) { refresh(); return; }
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['data-real-count'], childList: true });
    /* esconder la barra mientras el carrito está abierto */
    new MutationObserver(function () {
      bar.classList.toggle('is-hidden', drawer.classList.contains('is-open'));
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
})();

/* Galería de producto: al cambiar de color, volver al inicio para ver sus fotos */
(function () {
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var pick = root.querySelector('[data-variant-picker]');
    var gal = root.querySelector('[data-gallery]');
    if (!pick || !gal) return;
    pick.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.getAttribute('data-option') !== root.dataset.colorIndex) return;
      setTimeout(function () {
        gal.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        var r = gal.getBoundingClientRect();
        if (window.matchMedia('(min-width: 990px)').matches && r.top < 0) window.scrollBy({ top: r.top - 120, behavior: 'smooth' });
      }, 60);
    });
  });
})();